export default "__VITE_ASSET__oOflg_ER__"